import { requestAuth, requestBaseService } from './index'
import { getToken } from '../../utils'
import { generateQueryString, GenerateQueryV2 } from '../../utils/query'

export const loginApi = (data) => {
  return requestAuth({
    url: 'member/public/v1/auth/login',
    method: 'POST',
    data,
  })
}

export const gsiLoginApi = (data) => {
  return requestBaseService({
    url: 'member/public/v1/google/login',
    method: 'POST',
    data,
  })
}

export const gsiRegisterApi = (data) => {
  return requestBaseService({
    url: 'member/public/v1/google/register',
    method: 'POST',
    data,
  })
}

export const firebaseTokenRegisterApi = (data) => {
  return requestBaseService({
    url: 'member/ex/v1/members/set-firebase-token',
    method: 'POST',
    data,
    headers: { Authorization: 'Bearer ' + getToken() },
  })
}

export const requestResetPassword = (payload) => {
  return requestBaseService({
    url: 'member/public/v1/auth/send-code/reset-password',
    method: 'GET',
    params: payload,
  })
}

export const getResetPasswordCodeStatus = (payload) => {
  return requestBaseService({
    url: `member/public/v1/auth/reset-password/code/${payload}`,
    method: 'GET',
  })
}

export const verifyResetPassword = (data) => {
  return requestBaseService({
    url: 'member/public/v1/auth/reset-password/verify',
    method: 'POST',
    data,
  })
}

export const logoutApi = (payload) => {
  const params = generateQueryString(payload.params)
  return requestAuth({
    url: `/member/ex/v1/auth/logout?${params}`,
    method: 'GET',
    headers: { Authorization: 'Bearer ' + getToken() },
  })
}

export const phoneVerification = (payload) => {
  return requestBaseService({
    url: 'member/public/v1/auth/send-code/login',
    method: 'POST',
    data: payload,
  })
}

export const loginPhone = (data) => {
  return requestBaseService({
    url: 'member/public/v1/auth/login-phone',
    method: 'POST',
    data,
  })
}

export const updatePassword = (payload) => {
  return requestAuth({
    url: 'member/ex/v1/members/change-password',
    method: 'POST',
    data: payload.body,
  })
}

export const register = (data) => {
  return requestAuth({
    url: '/member/public/v1/auth/register',
    method: 'POST',
    data,
  })
}

export const checkAccount = (payload) => {
  return requestAuth({
    url: '/member/public/v1/auth/account-check',
    method: 'POST',
    data: payload,
  })
}

export const verify = (payload) => {
  return requestAuth({
    url: '/member/public/v1/auth/register/verify',
    method: 'POST',
    data: payload,
  })
}

export const sendOTPRegister = (payload) => {
  return requestAuth({
    url: `/member/public/v1/auth/register/send-verification`,
    method: 'POST',
    data: payload,
  })
}

export const resendOTPRegister = (payload) => {
  return requestAuth({
    url: `/member/public/v1/auth/register/resend/${payload}`,
    method: 'GET',
  })
}

export const membershipStatus = () => {
  return requestAuth({
    url: '/member/ex/v1/member_products/membership',
    method: 'GET',
  })
}

export const memberSubscription = () => {
  return requestAuth({
    url: '/member/ex/v1/member_products/active',
    method: 'GET',
  })
}

export const memberFeature = (payload) => {
  const query = GenerateQueryV2(payload)
  return requestAuth({
    url: `/member/ex/v1/member_products/available?${query}`,
    method: 'GET',
  })
}

export const memberDetails = () => {
  return requestAuth({
    url: '/member/ex/v2/members/me',
    method: 'GET',
  })
}

export const refreshTokenApi = (payload) => {
  return requestAuth({
    url: '/member/public/v1/auth/refresh-token',
    method: 'POST',
    data: payload,
  })
}

const Auth = {
  loginApi,
  gsiLoginApi,
  gsiRegisterApi,
  firebaseTokenRegisterApi,
  requestResetPassword,
  getResetPasswordCodeStatus,
  verifyResetPassword,
  logoutApi,
  phoneVerification,
  loginPhone,
  updatePassword,
  register,
  checkAccount,
  verify,
  sendOTPRegister,
  resendOTPRegister,
  membershipStatus,
  memberSubscription,
  memberFeature,
  memberDetails,
  refreshTokenApi,
}

export default Auth
